import { useCallback, useEffect, useState } from "react";
import FetchData from "../../../Helper/HttpRequestHelper";
import { Button } from "react-bootstrap";
import { Spinner } from "../../components/misc";

const Publication = () => {
  const [loading, setLoading] = useState(true);
  const [publications, setPublications] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(0);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const res = await FetchData("member/publication");
    if (res.status_code === 200) {
      setPublications(res.data.data);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onDownload = async (file_id) => {
    setLoadingDownload(file_id);
    const res = await FetchData("laporan-publikasi/download/paid-report", {
      publication_product_id: file_id,
    });
    if (res.status_code === 200) {
      const data = res.data;
      window.open(data.url, "_blank");
    }
    setLoadingDownload(0);
  };

  return (
    <>
      <div className="d-flex">
        <h3 className="mb-1">File Publikasi</h3>
      </div>
      <hr style={{ borderColor: "#dedede", borderWidth: "2px" }} />
      <div className="mt-1">
        {loading && <div>Loading..</div>}
        {loading === false && publications.length === 0 && (
          <div>Belum ada file publikasi</div>
        )}
        {loading === false &&
          publications.length > 0 &&
          publications.map((publication, index) => {
            return (
              <div className="card mb-4 card-transaction" key={index}>
                <div className="card-body">
                  <div className="card-title d-flex justify-content-between align-items-center">
                    <div className="invoice-label">
                      No. {publication?.invoice_number}
                    </div>
                  </div>
                  <div className="card-text">
                    <dl className="d-flex">
                      <dt className="col-4 col-md-3">Nama File</dt>
                      <dd>{publication?.description}</dd>
                    </dl>
                    <dl className="d-flex">
                      <dt className="col-4 col-md-3">Status</dt>
                      <dd>{publication?.publication_access}</dd>
                    </dl>
                  </div>
                  <div className="card-footer d-flex justify-content-end align-items-center">
                    <Button
                      variant="success"
                      className="w-10"
                      size="sm"
                      style={{ width: "100px" }}
                      onClick={() =>
                        onDownload(publication?.publication_product_id)
                      }
                    >
                      {loadingDownload ===
                      publication?.publication_product_id ? (
                        <span>
                          <Spinner animation="border" size="sm" />
                        </span>
                      ) : (
                        `Download`
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Publication;
